<div class="search-bar-container">
    <div class="container">
        <div class="free-delivery-mobile">
            <h3>
                {{ 'shoppingCart.freeDelivery' | translate }}
                <a href="https://jogkodex.hu/jsz/2024_13_torveny_6486371?ts=kozlony#pl9%C2%A7"
                    target="_blank"><mat-icon>info</mat-icon></a>
            </h3>
        </div>
        <div class="search-bar">
            <mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="search" />
            <input type="search" placeholder="Szerző, cím neve" [(ngModel)]="listFilter" />
        </div>
        <div class="free-delivery">
            <h3>
                {{ 'shoppingCart.freeDelivery' | translate }}
                <a href="https://jogkodex.hu/jsz/2024_13_torveny_6486371?ts=kozlony#pl9%C2%A7"
                    target="_blank"><mat-icon>info</mat-icon></a>
            </h3>
        </div>
    </div>
    <div class="mat-select">
        <mat-form-field>
            <mat-label>Rendezés</mat-label>
            <mat-select id="statuses">
                <mat-option value="Legújabb elöl" (click)="orderByNewest()">{{ 'materials.newestFirst' | translate
                    }}</mat-option>
                <mat-option value="Ár szerint növekvő" (click)="orderbyAscPrice()">{{
                    'materials.ascendingPrice' | translate
                    }}</mat-option>
                <mat-option value="Ár szerint csökkenő" (click)="orderbyDescPrice()">{{
                    'materials.descendingPrice' | translate
                    }}</mat-option>
                <mat-option value="Cím szerint A-Z" (click)="orderbyTitleAbc()">{{ 'materials.titleA_Z' | translate
                    }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="materials-container">
    @if (allProducts.length > 0) {
    <div class="soon-published">
        <div class="soon-pub">
            <h3>ÖSSZES KÖNYV</h3>
        </div>
    </div>
    }
    @if (allProducts.length > 0) {
    <div class="soon-container-home">
        <div class="main">
            @for (product of filteredPublication; track product) {
            <app-product-preview [product]="product" [extended]="true" (addToCart)="addToCart($event)" />
            }
        </div>
    </div>
    }
</div>